import { render, staticRenderFns } from "./AnimatedNumber.vue?vue&type=template&id=7bfb404a&scoped=true&lang=pug&"
import script from "./AnimatedNumber.vue?vue&type=script&lang=js&"
export * from "./AnimatedNumber.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedNumber.vue?vue&type=style&index=0&id=7bfb404a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb404a",
  null
  
)

export default component.exports